export type TagColor =
	| "gray_light"
	| "red_light"
	| "orange_light"
	| "yellow_light"
	| "green_light"
	| "blue_light"
	| "violet_light"
	| "pink_light";

export interface TagColorDefinition {
	value: TagColor;
	label: string;
	bg: string;
	text: string;
	ring: string;
	border?: string;
}

export const TAG_COLORS: TagColorDefinition[] = [
	{ value: "gray_light", label: "Grey", bg: "bg-gray-200", text: "text-gray-700", ring: "ring-gray-400", border: "border border-gray-400" },
	{ value: "red_light", label: "Red", bg: "bg-red-200", text: "text-red-700", ring: "ring-red-400", border: "border border-red-400" },
	{ value: "orange_light", label: "Orange", bg: "bg-orange-200", text: "text-orange-700", ring: "ring-orange-400", border: "border border-orange-400" },
	{ value: "yellow_light", label: "Yellow", bg: "bg-yellow-200", text: "text-yellow-700", ring: "ring-yellow-400", border: "border border-yellow-400" },
	{ value: "green_light", label: "Green", bg: "bg-green-200", text: "text-green-700", ring: "ring-green-400", border: "border border-green-400" },
	{ value: "blue_light", label: "Blue", bg: "bg-blue-200", text: "text-blue-700", ring: "ring-blue-400", border: "border border-blue-400" },
	{ value: "violet_light", label: "Violet", bg: "bg-violet-200", text: "text-violet-700", ring: "ring-violet-400", border: "border border-violet-400" },
	{ value: "pink_light", label: "Pink", bg: "bg-pink-200", text: "text-pink-700", ring: "ring-pink-400", border: "border border-pink-400" },
];

export function getTagColorStyles(color: string | null | undefined): TagColorDefinition {
	const found = TAG_COLORS.find((c) => c.value === color);
	return found ?? TAG_COLORS[0];
}

export function isValidTagColor(color: string): color is TagColor {
	return TAG_COLORS.some((c) => c.value === color);
}
